import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import { Stack } from "react-bootstrap";
import useScriptsStore from "../stores/Scripts";
import useUserStore from "../stores/User";
import { numberFormatter } from "../utils/Numbers";
import supabase from "../utils/Supabase";

import SocialLinks from "../components/SocialLinks";
import {
  TypewriterCursor,
  TypewriterEffect,
} from "../components/TypewriterEffect";
import { CombinedNav, SiteNav, UserNav } from "../components/UserNav";
import ThemeToggle from "../components/ThemeToggle";
import logo from "../img/sh-logo_site.png";

function Home() {
  const navigate = useNavigate();
  const isUserLoggedIn = useUserStore((state) => state.isLoggedIn());

  const totalScriptsCount = useScriptsStore((state) => state.totalCount);
  const setTotalScriptsCount = useScriptsStore((state) => state.setTotalCount);

  const searchScriptsCount = async () => {
    const { data, error } = await supabase
      .rpc("scripts_count");

    if (!data || error) {
      console.error("Failed to fetch scripts count:", error);
      return;
    }

    setTotalScriptsCount(data);
  };

  useEffect(() => {
    if (totalScriptsCount > 0) {
      return;
    }

    searchScriptsCount();
  }, [totalScriptsCount, navigate]); // Added dependency array

  return (
    <>
      <div className=" d-flex mt-2">
        <div className="ms-auto">
        <SocialLinks align="right" text="false" />
      </div>
    </div>

      <main className="home d-flex">
        <div className="home-column d-flex flex-column mx-3 mx-sm-auto">
          <img
            src={logo}
            className="home-logo d-block mx-auto mt-auto"
            alt="Script Hive logo"
          />

          <p className="mt-3 lead">
            Because scripts should be free. #ReadTheMovies
          </p>

          <div className="my-2 mx-4">
            {isUserLoggedIn ? (
              <Stack direction="horizontal" className="d-flex flex-wrap justify-content-center" gap={1}>
                <CombinedNav setOpen={() => true} />
                <ThemeToggle />
              </Stack>
            ) : (
              <>
                <Stack direction="horizontal" className="d-flex flex-wrap justify-content-center">
                  <SiteNav />
                  <UserNav />
                </Stack>
              </>
            )}
          </div>

          <p className="lead mb-auto">
            Current number of screenplays in database:{" "}
            {totalScriptsCount > 0 ? (
              <TypewriterEffect>
                {numberFormatter(totalScriptsCount)}
              </TypewriterEffect>
            ) : (
              <TypewriterCursor />
            )}
          </p>

          <p className="home-disclaimer fs-6 py-2 px-3 rounded bg-body-tertiary text-muted mb-3 mb-md-6">
            Script Hive is an educational resource supporting screenwriters,
            filmmakers, educators, students, and researchers. Please review our{" "}
            <Link to="/legal">Legal &amp; DMCA Policy</Link> regarding
            copyright, educational use, and DMCA requests.
          </p>
        </div>
      </main>
    </>
  );
}

export default Home;
